module.exports = __webpack_public_path__ + "img/rudy.77b9bd78.png";